'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconShieldXmark, iconShieldXmarkTag } from '@ni/nimble-components/dist/esm/icons/shield-xmark';
import { wrap } from '../../utilities/react-wrapper';

export type { IconShieldXmark };
export { iconShieldXmarkTag };
export const NimbleIconShieldXmark = wrap(IconShieldXmark);